module.exports = __webpack_public_path__ + "img/pressure_label.45ce2e64.svg";